import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { AlertTriangle, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

interface RouterContext {
  queryClient: QueryClient;
}

function ErrorPage({ error }: { error: Error }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center gap-2 text-rose-600">
            <AlertTriangle className="h-5 w-5" />
            <CardTitle>Bir hata oluştu</CardTitle>
          </div>
          <CardDescription>{error.message || 'Beklenmeyen bir hata.'}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <Button asChild className="w-full">
            <Link to="/dashboard">Ana sayfaya dön</Link>
          </Button>
          <Button variant="outline" className="w-full" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>404 — Sayfa bulunamadı</CardTitle>
          <CardDescription>Aradığınız sayfa mevcut değil.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <Link to="/dashboard">
              <Home className="h-4 w-4" />
              Ana sayfaya dön
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  errorComponent: ErrorPage,
  notFoundComponent: NotFoundPage,
});
